// English strings for the 3D AI mascot (D-057) and root's chat panel (D-060). Keys read
// `t("aiMascot.…")`. Copy rule: "root" is always lowercase and never starts a sentence.
export const aiMascotStrings = {
  hello: {
    title: "Hi",
  },
  chat: {
    greeting: "Hi {store}, how can I help you?",
    placeholder: "Ask root anything",
    send: "Send",
    newChat: "New chat",
    log: "Chat with root",
    you: "You",
    rootSaid: "root said",
    waiting: "Waiting for root's reply",
    hint: "Enter to send · Shift + Enter for a new line",
    noCredits:
      "I'm out of root credits. Add some on the Adyvance Wallet page (Spend it on → root AI credits) and I'll keep going.",
    notConnected:
      "I'm not connected to AI yet, so I can't answer that. My replies start once AI is connected for Adyvance.",
    assistant: "AI assistant",
    status: {
      online: "Online",
      offline: "Not connected yet",
    },
    intro: "Ask me about orders, products, stock, customers or settings.",
    tryAsking: "Try asking",
    prompts: {
      orders: "Where do I see today's orders?",
      product: "How do I add a new product?",
      delivery: "How do I set delivery charges?",
      whatsapp: "How do I connect WhatsApp?",
    },
    offlineNote: "AI isn't connected yet, so answers are paused for now.",
    disclaimer: "Answers can be wrong. Check important details.",
  },
  /** The log-in page: root pulls in one board per part of Adyvance (D-063). */
  showcase: {
    label: "What Adyvance does",
    hello: "Hi, I'm root! Let me show you what Adyvance can do.",
    bye: "That's Adyvance! Log in and let's grow your shop.",
    meet: "Meet root",
    boards: {
      ecommerce: {
        eyebrow: "Ecommerce",
        title: "Your online store",
        lead: "Sell online with a store that works for you.",
        p1: "Your own store design and web address",
        p2: "Orders, stock and customers in one place",
        p3: "Couriers and payments together",
        p4: "Point of sale for your shop counter",
        tiles: { store: "Store", orders: "Orders", stock: "Stock", couriers: "Couriers" },
      },
      import: {
        eyebrow: "Import products",
        title: "Product Import",
        lead: "Buy stock from suppliers outside Nepal.",
        p1: "Find products from suppliers abroad",
        p2: "Ask for a price before you buy",
        p3: "Track every import until it arrives",
        p4: "All your import orders in one list",
        tiles: {
          suppliers: "Suppliers",
          quote: "Price quote",
          shipping: "Shipping",
          tracking: "Tracking",
        },
      },
      marketing: {
        eyebrow: "Digital marketing",
        title: "Grow with ads",
        lead: "Reach more buyers, with our team behind you.",
        p1: "Meta and Google ads run for you",
        p2: "SMS campaigns to your customers",
        p3: "Coupons and discounts for every season",
        p4: "See what each campaign earns in Reports",
        tiles: {
          meta: "Meta",
          google: "Google",
          sms: "SMS",
          coupons: "Coupons",
          reports: "Reports",
        },
      },
      sampark: {
        eyebrow: "Sampark",
        title: "Every chat, one inbox",
        lead: "Reply to every customer from one place.",
        p1: "Website, Messenger, Instagram, WhatsApp, TikTok",
        p2: "Let root answer while you are busy",
        p3: "Turn a chat into an order",
        p4: "The customer's details beside every chat",
        tiles: {
          website: "Website",
          messenger: "Messenger",
          instagram: "Instagram",
          whatsapp: "WhatsApp",
          tiktok: "TikTok",
        },
      },
      daraz: {
        eyebrow: "Daraz",
        title: "Your Daraz shop, here",
        lead: "Run your Daraz store without switching apps.",
        p1: "Pack, print labels and ship Daraz orders",
        p2: "Stock synced every 10 minutes",
        p3: "See your Daraz payouts",
        p4: "Daraz orders join your other orders",
        tiles: {
          daraz: "Daraz",
          orders: "Orders",
          labels: "Labels",
          sync: "Sync",
          payouts: "Payouts",
        },
      },
    },
  },
} as const;
